import { useTranslations } from 'js/hooks/i18n';
import React, { useState, useEffect, memo } from 'react';
import { WarningMessage } from 'js/components/common/Fields/WarningMessage';

import * as Types from './types';
import * as constants from './constants';

export const TwoFactorWarningMessageBare: React.FC<Types.ITwoFactorWarningMessageProps> = ({
    setIsResendDisabled,
    setIsResendWarningShown
}) => {
    const [secondsLeft, setSecondsLeft] = useState<number>(constants.RESEND_COOL_DOWN);
    const translate = useTranslations('playtech.mobile.system.2FA.popup.');

    useEffect(() => {
        const interval = setInterval(() => {
            setSecondsLeft((prev: number) => {
                if (prev === 0) {
                    clearInterval(interval);
                    setIsResendDisabled(false);
                    setIsResendWarningShown(false);

                    return prev;
                }

                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [setIsResendDisabled, setIsResendWarningShown]);

    return <WarningMessage warning={translate('resendCoolDownError', [secondsLeft])} />;
};

export const TwoFactorWarningMessage = memo(TwoFactorWarningMessageBare);
